/* ==========================================================================
   TRC Free Gift · cart drawer add-on (Nov 2026)
   Spend $300 → free Travel Jewellery Organiser.
   Loaded after trco-cart-v3-d.js by snippets/trco-cart-drawer.liquid, which
   also holds the settings (#trc-free-gift-config: threshold, variant, wording).

   The price drop to $0 comes from the Shopify automatic discount
   "Free Travel Jewellery Organiser (orders over $300)" (Buy X Get Y, buys from
   the hidden "Free Organiser Qualifying" collection). This file only:
     • shows a progress bar at the top of the drawer
     • adds the organiser (tagged _free_gift) once the cart reaches $300
     • removes it again if the cart drops below $300
     • removes it if Shopify isn't making it free (e.g. a discount code that
       can't combine), so nobody is charged for a "free" gift
     • respects a customer who removes it (offers an "Add it" button instead)
   ========================================================================== */
(function () {
  'use strict';
  var T = window.__trco; if (!T) return;
  var Ctrl = T.Ctrl, esc = T.esc, postJSON = T.postJSON, formatMoney = T.formatMoney;

  var cfgEl = document.getElementById('trc-free-gift-config');
  if (!cfgEl) return;
  var G;
  try { G = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!G || !G.variantId || !G.threshold) return;

  var VID = Number(G.variantId);
  var PROP = '_free_gift';
  var DECLINED_KEY = 'trcFreeGiftDeclined';

  function declined() { try { return sessionStorage.getItem(DECLINED_KEY) === '1'; } catch (e) { return false; } }
  function setDeclined(v) { try { v ? sessionStorage.setItem(DECLINED_KEY, '1') : sessionStorage.removeItem(DECLINED_KEY); } catch (e) {} }

  function isGift(it) { return Number(it.variant_id || it.id) === VID; }
  function isAutoGift(it) { return isGift(it) && it.properties && it.properties[PROP]; }

  function qualifyingTotal(cart) {
    return ((cart && cart.items) || []).reduce(function (s, it) {
      if (isGift(it)) return s;
      var line = it.original_line_price != null ? it.original_line_price : (it.price || 0) * (it.quantity || 0);
      return s + line;
    }, 0);
  }

  /* ---- styles ----------------------------------------------------------- */
  var css = document.createElement('style');
  css.textContent = [
    '.trc-gift{padding:12px 16px;border-bottom:1px solid rgba(0,0,0,.08);background:var(--trco-bg,#fff);font-size:13px;line-height:1.4;color:var(--trco-text,#000)}',
    '.trc-gift[hidden]{display:none}',
    '.trc-gift__row{display:flex;align-items:center;gap:10px}',
    '.trc-gift__img{flex:0 0 auto;width:36px;height:36px;object-fit:cover;border-radius:4px;background:#f6f6f7}',
    '.trc-gift__text{flex:1 1 auto}',
    '.trc-gift__text strong{font-weight:700}',
    '.trc-gift__bar{position:relative;height:6px;margin-top:8px;border-radius:3px;background:#ececec;overflow:hidden}',
    '.trc-gift__fill{position:absolute;left:0;top:0;bottom:0;border-radius:3px;background:var(--trco-timer-bar,#eab4dd);transition:width .35s ease}',
    '.trc-gift.is-unlocked .trc-gift__fill{background:var(--trco-savings,#35913f)}',
    '.trc-gift__add{margin-left:6px;padding:0;border:0;background:none;color:inherit;font:inherit;font-weight:700;text-decoration:underline;cursor:pointer}',
    '.trco-item__gift{display:inline-block;margin-top:4px;padding:2px 6px;border-radius:3px;background:var(--trco-savings,#35913f);color:#fff;font-size:11px;font-weight:700;letter-spacing:.04em;text-transform:uppercase}',
    '.trco-item--gift .trco-qty{display:none}'
  ].join('');
  document.head.appendChild(css);

  /* ---- progress bar ----------------------------------------------------- */
  Ctrl.prototype.giftBarEl = function () {
    if (this._giftBar) return this._giftBar;
    var body = this.$('[data-trco-body]');
    if (!body) return null;
    var el = document.createElement('div');
    el.className = 'trc-gift';
    el.setAttribute('aria-live', 'polite');
    el.hidden = true;
    body.parentNode.insertBefore(el, body);
    var self = this;
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-trc-gift-add]')) { setDeclined(false); self._giftFailed = false; self.syncGift(true); }
    });
    this._giftBar = el;
    return el;
  };

  Ctrl.prototype.renderGiftBar = function () {
    var el = this.giftBarEl();
    if (!el) return;
    var cart = this.cart;
    var hasItems = cart && (cart.items || []).some(function (it) { return !isGift(it); });
    var giftInCart = cart && (cart.items || []).some(isGift);
    if (!hasItems || (!G.available && !giftInCart)) { el.hidden = true; el.innerHTML = ''; return; }

    var total = qualifyingTotal(cart);
    var pct = Math.min(100, Math.round((total / G.threshold) * 100));
    var unlocked = total >= G.threshold;
    var name = esc(G.title || 'Travel Jewellery Organiser');
    var msg;
    if (!unlocked) {
      msg = (G.copyAway || "You're {amount} away from a FREE {gift}")
        .replace('{amount}', '<strong>' + formatMoney(G.threshold - total) + '</strong>')
        .replace('{gift}', name);
    } else if (this._giftBlocked) {
      msg = G.copyBlocked || "Your discount code can't be combined with the free organiser.";
      msg = esc(msg);
    } else {
      msg = (G.copyUnlocked || "You've unlocked a FREE {gift}!").replace('{gift}', name);
      if (!giftInCart && G.available) {
        msg += ' <button type="button" class="trc-gift__add" data-trc-gift-add>' + esc(G.copyAdd || 'Add it to your order') + '</button>';
      }
    }
    var img = G.image ? '<img class="trc-gift__img" src="' + esc(G.image) + '" alt="" width="36" height="36" loading="lazy">' : '';
    var html =
      '<div class="trc-gift__row">' + img + '<div class="trc-gift__text">' + msg + '</div></div>' +
      '<div class="trc-gift__bar"><span class="trc-gift__fill" style="width:' + pct + '%"></span></div>';
    el.classList.toggle('is-unlocked', unlocked && !this._giftBlocked);
    if (html !== this._lastGiftHTML) { el.innerHTML = html; this._lastGiftHTML = html; }
    el.hidden = false;
  };

  /* ---- add / remove the gift ------------------------------------------- */
  Ctrl.prototype.syncGift = function (force) {
    var self = this;
    var cart = this.cart;
    if (!cart || this._giftBusy || this._loading) return;
    var items = cart.items || [];
    var total = qualifyingTotal(cart);
    var unlocked = total >= G.threshold;
    var gifts = items.filter(isGift);
    var autoGifts = items.filter(isAutoGift);
    var op = null;

    if (!unlocked) {
      this._giftBlocked = false;
      if (autoGifts.length) op = function () { return postJSON('cart/change.js', { id: autoGifts[0].key, quantity: 0 }); };
    } else if (autoGifts.length) {
      var g = autoGifts[0];
      var lineNow = g.final_line_price != null ? g.final_line_price : g.line_price;
      if (g.quantity > 1) {
        op = function () { return postJSON('cart/change.js', { id: g.key, quantity: 1 }); };
      } else if (lineNow > 0) {
        // Shopify isn't making it free (e.g. a code that can't combine): don't charge for it.
        this._giftBlocked = true;
        op = function () { return postJSON('cart/change.js', { id: g.key, quantity: 0 }); };
      }
    } else if (!gifts.length && G.available && !this._giftFailed && !this._giftBlocked && (force || !declined())) {
      op = function () {
        var props = {}; props[PROP] = '1';
        return postJSON('cart/add.js', { items: [{ id: VID, quantity: 1, properties: props }] }).then(function (res) {
          if (res && res.status && res.status >= 400) self._giftFailed = true;   // sold out etc.
        });
      };
    }

    if (!op) return;
    this._giftBusy = Promise.resolve().then(op).catch(function () { self._giftFailed = true; })
      .then(function () { self._giftBusy = null; return self.refresh(false); });
  };

  // A code change can make the gift free again: let it try once more.
  var origApply = Ctrl.prototype.applyDiscount;
  if (origApply) Ctrl.prototype.applyDiscount = function () { this._giftBlocked = false; return origApply.apply(this, arguments); };
  var origRemove = Ctrl.prototype.removeDiscount;
  if (origRemove) Ctrl.prototype.removeDiscount = function () { this._giftBlocked = false; return origRemove.apply(this, arguments); };

  /* ---- line item: FREE GIFT label, no quantity buttons ------------------ */
  var origItemHTML = Ctrl.prototype.itemHTML;
  Ctrl.prototype.itemHTML = function (it) {
    var html = origItemHTML.call(this, it);
    if (!isAutoGift(it)) return html;
    html = html.replace('class="trco-item"', 'class="trco-item trco-item--gift"');
    var marker = '</div><div class="trco-item__right">';
    var tag = '<div><span class="trco-item__gift">' + esc(G.copyTag || 'Free gift') + '</span></div>';
    return html.indexOf(marker) === -1 ? html : html.replace(marker, tag + marker);
  };

  var origRender = Ctrl.prototype.render;
  Ctrl.prototype.render = function () {
    var r = origRender.apply(this, arguments);
    var gifts = ((this.cart && this.cart.items) || []).filter(isGift);
    this._giftKeys = gifts.map(function (g) { return g.key; });
    this.renderGiftBar();
    this.syncGift(false);
    window.__trcGiftCtrl = this;
    return r;
  };

  // Customer removes the gift themselves → don't put it straight back.
  document.addEventListener('click', function (e) {
    var rm = e.target && e.target.closest && e.target.closest('[data-trco-remove]');
    var c = window.__trcGiftCtrl;
    if (!rm || !c || !c._giftKeys) return;
    if (c._giftKeys.indexOf(rm.getAttribute('data-key')) !== -1) setDeclined(true);
  }, true);

  // Checkout waits for any gift add/remove that's still in flight.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-trco-checkout]');
    var c = window.__trcGiftCtrl;
    if (!btn || !c || !c._giftBusy) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    c._giftBusy.then(function () { window.location.href = T.url('checkout'); });
  }, true);
})();
